import styled, { css } from "styled-components";

export const Wrapper = styled.div(({ theme }) => css`
  font-size: 16px;
  line-height: 1.6;
  text-align: center;
  padding: 12px 20px;
  color: black;

  a {
    color: ${theme.buttons.link.color};
    text-decoration: underline;

    &:hover {
      color: ${theme.buttons.link.hoverColor};
    }
  }
`);